module.exports = __webpack_public_path__ + "img/empty-state-team-roster.73783d39.svg";